import React, { useState } from "react";
import { Sparkles, Loader2 } from "lucide-react";
import toast from "react-hot-toast";

import { proposalAi } from "../api/prospectingReportsApi";

/**
 * "Write with AI" / "Refine" button for one AI-writable block field (V2).
 * Calls the AI endpoint and hands the text back via onText — it does not save;
 * the builder's normal autosave persists it.
 */
const ProposalAiButton = ({ proposalId, blockType, field, currentText = "", onText }) => {
  const [busy, setBusy] = useState(false);
  const hasText = Boolean((currentText || "").trim());

  const run = async () => {
    if (!proposalId) return;
    setBusy(true);
    try {
      const { data } = await proposalAi(proposalId, {
        block_type: blockType,
        field,
        mode: hasText ? "refine" : "generate",
        current_text: currentText || "",
      });
      if (data?.text) {
        onText(data.text);
        if (data.degraded) {
          toast("AI is unavailable right now — inserted a starter draft to edit.", { icon: "✏️" });
        }
      }
    } catch (e) {
      toast.error("Couldn't generate copy. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={run}
      disabled={busy}
      title={hasText ? "Refine this with AI" : "Write this with AI"}
      className="inline-flex items-center gap-1 text-[11px] font-semibold text-[#0f8d9b] hover:text-[#0b6f7a] disabled:opacity-50"
    >
      {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <Sparkles className="w-3 h-3" />}
      {hasText ? "Refine" : "Write with AI"}
    </button>
  );
};

export default ProposalAiButton;
